import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const INITIAL_STATE = { name: "", email: "", phone: "", service: "", message: "" };

export const Contact = ({ data }) => {
  const d = data || {};
  const f = d.form || {};
  const s = d.social || {};
  const ejs = d.emailjs || {};

  const [fields, setFields] = useState(INITIAL_STATE);
  const [status, setStatus] = useState(null); // null | "sending" | "success" | "error"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");
    emailjs
      .sendForm(ejs.service_id, ejs.template_id, e.target, ejs.public_key)
      .then(
        () => { setStatus("success"); setFields(INITIAL_STATE); },
        () => { setStatus("error"); }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">

          {/* ── Form column ───────────────────────────────── */}
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>{d.heading || "Ready to Grow Your Business?"}</h2>
                <p>{d.subheading}</p>
              </div>

              {status === "success" ? (
                <div className="contact-success">
                  <i className="fa fa-check-circle"></i>
                  <p>{f.success_message}</p>
                </div>
              ) : (
                <form name="sentMessage" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={fields.name}
                          className="form-control"
                          placeholder={f.name_placeholder || "Your Name"}
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={fields.email}
                          className="form-control"
                          placeholder={f.email_placeholder || "Your Email"}
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={fields.phone}
                          className="form-control"
                          placeholder={f.phone_placeholder || "Your Phone Number"}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <select
                          id="service"
                          name="service"
                          value={fields.service}
                          className="form-control"
                          onChange={handleChange}
                        >
                          <option value="" disabled>
                            {f.service_default || "What do you need help with?"}
                          </option>
                          {(f.services || []).map((svc, i) => (
                            <option key={i} value={svc}>{svc}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      value={fields.message}
                      className="form-control"
                      rows="4"
                      placeholder={f.message_placeholder || "Tell us about your business and goals..."}
                      required
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {status === "error" && (
                    <p className="contact-error">{f.error_message}</p>
                  )}

                  <button
                    type="submit"
                    className="btn btn-custom btn-lg"
                    disabled={status === "sending"}
                  >
                    {status === "sending" ? "Sending…" : (f.submit_label || "Send Enquiry")}
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* ── Info column ───────────────────────────────── */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>{d.info_heading || "Contact Info"}</h3>
              <p>
                <span><i className="fa fa-map-marker"></i> Address</span>
                {d.address}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span><i className="fa fa-phone"></i> Phone</span>
                {d.phone}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span><i className="fa fa-envelope-o"></i> Email</span>
                <a href={`mailto:${d.email}`}>{d.email}</a>
              </p>
            </div>
            {d.response_label && (
              <div className="contact-item contact-response">
                <p>
                  <span><i className="fa fa-clock-o"></i> {d.response_label}</span>
                  {d.response_time}
                </p>
              </div>
            )}
            {d.trust_line && (
              <p className="contact-trust">{d.trust_line}</p>
            )}
          </div>

          {/* ── Social row ────────────────────────────────── */}
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  {s.facebook  && <li><a href={s.facebook}  aria-label="Facebook" ><i className="fa fa-facebook" ></i></a></li>}
                  {s.twitter   && <li><a href={s.twitter}   aria-label="Twitter"  ><i className="fa fa-twitter"  ></i></a></li>}
                  {s.instagram && <li><a href={s.instagram} aria-label="Instagram"><i className="fa fa-instagram"></i></a></li>}
                  {s.youtube   && <li><a href={s.youtube}   aria-label="YouTube"  ><i className="fa fa-youtube"  ></i></a></li>}
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Footer ───────────────────────────────────────── */}
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()}{" "}
            {data && data._footer ? data._footer.company : "CocoAutomation Ltd."}{" "}
            {data && data._footer ? data._footer.registered : "Registered in England & Wales"}.{" "}
            {data && data._footer ? data._footer.address : "80 White Road, Oxford, OX4 2JL, UK"}.
          </p>
        </div>
      </div>
    </div>
  );
};
